import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-5e94916b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container-xl" };
const _hoisted_2 = { class: "table-responsive" };
const _hoisted_3 = { class: "table-wrapper" };
const _hoisted_4 = { class: "table-title" };
const _hoisted_5 = { class: "row" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "content_edit" };
const _hoisted_9 = { class: "input-group" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "input-group-text" }, "Title", -1));
const _hoisted_11 = { class: "input-group" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "input-group-text" }, "Description", -1));
const _hoisted_13 = { class: "input-group-text" };
const _hoisted_14 = ["onUpdate:modelValue"];
const _hoisted_15 = { class: "image_cont" };
const _hoisted_16 = ["src"];
const _hoisted_17 = ["onChange"];
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_19 = ["src"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = { class: "aligned" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "adding_item" }, "Save", -1));
const _hoisted_23 = [
    _hoisted_22
];
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "adding_item" }, "Cancel", -1));
const _hoisted_25 = [
    _hoisted_24
];
import 'vue-final-modal/style.css';
import '../../assets/styles/boot.min.css';
import '../../assets/styles/font.min.css';
import { ref, watch, onUnmounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import api from '../../api';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditorItem',
    props: {
        title: String,
        category: String,
        item: null
    },
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const props = __props;
        const items = ref([]);
        const item = ref({ id: null, title: '', description: '', text1: '', text2: '', text3: '', text4: '', image1: '', image2: '', image3: '', image4: '' });
        const array = [1, 2, 3, 4];
        const itemsUploader = ref({
            image1: null,
            image2: null,
            image3: null,
            image4: null
        });
        const revokeUploader = ref({
            image1: false,
            image2: false,
            image3: false,
            image4: false
        });
        const name = ref('');
        const isAble = ref(false);
        const createdUrls = new Set();
        // // Extract the query parameter 'item'
        // const itemId = computed(() => {
        //   // 'item' is the query parameter name
        //   return route.query.item || 'No ID provided';
        // });
        const itemId = route.query.item;
        // Fetch users data
        const fetchUsers = async () => {
            console.log('fecth : ', props.title);
            try {
                const response = await api.get('items_list.php', {
                    params: { id: itemId, cat: props.title }
                });
                if (response.data.status === 'success') {
                    items.value = response.data.list;
                    item.value = items.value[0];
                    name.value = item.value.title;
                }
                console.log(response.data);
            }
            catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        if (itemId !== "null")
            fetchUsers();
        const cancel = async () => {
            try {
                const str = props.title || '';
                router.push(str.toLowerCase());
            }
            catch (error) {
                console.error('Request error:', error);
                //router.push('users');
            }
        };
        const change = async () => {
            try {
                const str = props.title || '';
                const formData = new FormData();
                formData.append('cat', str);
                formData.append('description', item.value.description);
                formData.append('title', name.value);
                formData.append('text1', item.value.text1);
                formData.append('text2', item.value.text2);
                formData.append('text3', item.value.text3);
                formData.append('text4', item.value.text4);
                // Handle file inputs from item.value and imagePreviews.value
                // Ensure the images are appended correctly
                for (let i = 1; i < array.length + 1; i++) {
                    let imageBlob = itemsUploader.value["image" + i];
                    let revoke = revokeUploader.value["image" + i];
                    if (imageBlob) {
                        formData.append('image' + i, imageBlob.file);
                    }
                    if (revoke)
                        formData.append('revokimage' + i, "yes");
                }
                let debug = true;
                if (debug) {
                    let response;
                    if (itemId === "null") {
                        response = await api.post('add_list.php', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                    }
                    else {
                        const id = itemId || '';
                        console.log("changing this item:", id);
                        formData.append('id', id);
                        formData.forEach((value, key) => {
                            console.log(key, value);
                        });
                        response = await api.post('edit_item.php', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                    }
                    if (response.data.status === 'success') {
                        console.log('User edit successfully', response.data);
                        router.push(str.toLowerCase());
                        // Refresh user list or handle success
                    }
                    else {
                        console.error('Error edit user:', response.data);
                        //router.push('users');
                    }
                }
            }
            catch (error) {
                console.error('Request error:', error);
                //router.push('users');
            }
        };
        const handleFileUpload = (event, imageField) => {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    const binaryString = reader.result;
                    const base64String = btoa(binaryString);
                    const dataUrl = `data:image/jpeg;base64,${base64String}`;
                    const itemFile = {
                        file: file,
                        string: dataUrl,
                    };
                    itemsUploader.value[imageField] = itemFile;
                    revokeUploader.value[imageField] = false;
                };
                // Read the file as a binary string
                reader.readAsBinaryString(file);
            }
        };
        const checkVisibility = (img) => {
            if (itemId !== "null" && item.value[img])
                return true;
            else
                return false;
        };
        const checkVisibilityPreview = (img) => {
            if (itemsUploader.value[img] && itemsUploader.value[img].file)
                return true;
            else
                return false;
        };
        // const convertBlobToFile = (blobUrl:string, fileName:string) => {
        //   return fetch(blobUrl)
        //     .then(response => response.blob())
        //     .then(blob => new File([blob], fileName, { type: blob.type }));
        // };
        const returnImageUploaded = (img) => {
            const itemUploader = itemsUploader.value[img];
            if (itemId.value !== 'null' && itemUploader) {
                return itemUploader.string;
            }
            return ''; // Return empty string if no image is available
        };
        const returnImage = (img) => {
            const imageBlob = item.value[img];
            if (itemId.value !== 'null' && imageBlob) {
                return 'data:image/jpeg;base64,' + imageBlob;
            }
            //return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=='
            return ''; // Return empty string if no image is available
        };
        const removeItem = (imageField) => {
            item.value[imageField] = null;
            itemsUploader.value[imageField] = null;
            revokeUploader.value[imageField] = true;
        };
        // Watch the `name` ref and update `isAble` accordingly
        watch(name, (newName, oldName) => {
            console.log(oldName);
            if (newName === "") {
                isAble.value = false;
            }
            else {
                isAble.value = true;
            }
        });
        onUnmounted(() => {
            // Clean up created URLs when the component is unmounted
            createdUrls.forEach(url => URL.revokeObjectURL(url));
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                (item.value.id != null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createTextVNode("Edit > "),
                                        _createElementVNode("b", null, _toDisplayString(item.value.title), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (item.value.id == null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "New " + _toDisplayString(__props.title), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "basic-url",
                                    "aria-describedby": "basic-addon3 basic-addon4",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event))
                                }, null, 512), [
                                    [_vModelText, name.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _hoisted_12,
                                _withDirectives(_createElementVNode("textarea", {
                                    name: "Text1",
                                    cols: "80",
                                    rows: "5",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((item.value.description) = $event))
                                }, null, 512), [
                                    [_vModelText, item.value.description]
                                ])
                            ]),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(array, (index) => {
                                return _createElementVNode("div", {
                                    class: "input-group style1",
                                    key: index
                                }, [
                                    _createElementVNode("span", _hoisted_13, "text " + _toDisplayString(index), 1),
                                    _withDirectives(_createElementVNode("textarea", {
                                        name: "Text{{index}}",
                                        cols: "40",
                                        rows: "5",
                                        "onUpdate:modelValue": ($event) => ((item.value['text' + index]) = $event)
                                    }, null, 8, _hoisted_14), [
                                        [_vModelText, item.value['text' + index]]
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                        (checkVisibilityPreview('image' + index))
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: returnImageUploaded('image' + index),
                                                alt: "Image 1 Preview"
                                            }, null, 8, _hoisted_16))
                                            : _createCommentVNode("", true),
                                        (!checkVisibilityPreview('image' + index) && !checkVisibility('image' + index))
                                            ? (_openBlock(), _createElementBlock("input", {
                                                key: 1,
                                                type: "file",
                                                onChange: ($event) => (handleFileUpload($event, 'image' + index))
                                            }, null, 40, _hoisted_17))
                                            : _createCommentVNode("", true),
                                        _hoisted_18,
                                        (checkVisibility('image' + index))
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 2,
                                                src: returnImage('image' + index),
                                                alt: "Image 1 Preview"
                                            }, null, 8, _hoisted_19))
                                            : _createCommentVNode("", true),
                                        (checkVisibility('image' + index) || checkVisibilityPreview('image' + index))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 3,
                                                onClick: ($event) => (removeItem('image' + index)),
                                                class: "fa fa-remove"
                                            }, null, 8, _hoisted_20))
                                            : _createCommentVNode("", true)
                                    ])
                                ]);
                            }), 64)),
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("button", {
                                    class: _normalizeClass([isAble.value ? '' : 'disabled', "btn btn-primary btn-block confirm_btn"]),
                                    onClick: change
                                }, _hoisted_23, 2),
                                _createElementVNode("button", {
                                    class: "btn btn-secondary btn-block confirm_btn",
                                    onClick: cancel
                                }, _hoisted_25)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
